export default __webpack_public_path__ + "static/media/payment-box-icon-01.6db9926a.png";